import { z } from 'zod'
import { isNotEmpty } from '../util/isEmpty'

export const DynamoStartKeySchema = z
  .record(z.string(), z.union([z.string(), z.number(), z.boolean()]))
  .refine((obj) => isNotEmpty(Object.keys(obj)))
